var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "router-link",
    { staticClass: "card card--event", attrs: { to: _vm.link } },
    [
      _c("div", { staticClass: "grid align-center" }, [
        _c("div", { staticClass: "col-lg-3 col-md-12" }, [
          _c("picture", { staticClass: "card__thumbnail" }, [
            _c("img", {
              staticClass: "card__image",
              attrs: { src: _vm.currEvent.backgroundImage, alt: "Event Image" },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-9 col-md-12" }, [
          _vm.currEvent.eventName
            ? _c("div", { staticClass: "card__header" }, [
                _c("h3", { staticClass: "card__title" }, [
                  _vm._v(_vm._s(_vm.currEvent.eventName)),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.currEvent.start
            ? _c("div", { staticClass: "card__body" }, [
                _c("p", [_vm._v(_vm._s(_vm.currEvent.start.displayDate))]),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }